import { StrictMode } from 'react'
import './index.css'
import App from './App.jsx'
import ReactDOM from 'react-dom/client'
import routes from './router/Router.jsx'
import React from "react";
import {RouterProvider} from "react-router-dom";
import dayjs from 'dayjs'
import 'dayjs/locale/ru';



dayjs.locale('ru-RU')


ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <RouterProvider router={routes} />
    </React.StrictMode>
);
